import styled from "styled-components"

export const StyledIframe = styled.iframe`
  background-color: rgba(235, 237, 242, 0.98);
  border: none;
  top: 80px;
  width: 100%;
`
